import { useCallback, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { LAST_MODIFIED_DATE, SURVEY_NAME, SURVEY_STATUS } from "../../../ducks/survey";

import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import { TEMPLATE_CREATOR } from "../../../common/constant";
import SurveyUtils from "../../../utils/SurveyUtils";
import TemplateListTableRows from "./TemplateListTableRows";

/**
 * The component displays survey templates.
 */
const TemplateListTable = (props) => {
  const { sortTableTemplateAscending, sortTableTemplateBy, sortColumn, roles } = props;

  const onSortColumn = useCallback(
    (columnType) => {
      //triggers sorting.
      if (sortTableTemplateBy === columnType) {
        sortColumn(columnType, !sortTableTemplateAscending);
      } else {
        sortColumn(columnType, true);
      }
    },
    [sortTableTemplateAscending, sortColumn, sortTableTemplateBy]
  );

  const isCreator = useMemo(() => roles.includes(TEMPLATE_CREATOR), [roles]);

  return (
    <BootstrapTable responsive striped hover>
      <thead>
        <tr>
          <th
            className={SurveyUtils.addClassForTableHeader(
              SURVEY_NAME,
              sortTableTemplateBy,
              sortTableTemplateAscending,
              "text-long"
            )}
          >
            <Button variant="link" onClick={() => onSortColumn(SURVEY_NAME)}>
              <FormattedMessage id="templateList.templateTitle" />
              {SurveyUtils.sortIcon(SURVEY_NAME, sortTableTemplateBy, sortTableTemplateAscending)}
            </Button>
          </th>
          <th
            className={SurveyUtils.addClassForTableHeader(
              SURVEY_STATUS,
              sortTableTemplateBy,
              sortTableTemplateAscending
            )}
          >
            <Button variant="link" onClick={() => onSortColumn(SURVEY_STATUS)}>
              <FormattedMessage id="templateList.status" />
              {SurveyUtils.sortIcon(SURVEY_STATUS, sortTableTemplateBy, sortTableTemplateAscending)}
            </Button>
          </th>
          {isCreator && (
            <th className="action">
              <FormattedMessage id="app.common.title.actions" />
            </th>
          )}
          <th
            className={SurveyUtils.addClassForTableHeader(
              LAST_MODIFIED_DATE,
              sortTableTemplateBy,
              sortTableTemplateAscending
            )}
          >
            <Button variant="link" onClick={() => onSortColumn(LAST_MODIFIED_DATE)}>
              <FormattedMessage id="templateList.updated" />
              {SurveyUtils.sortIcon(LAST_MODIFIED_DATE, sortTableTemplateBy, sortTableTemplateAscending)}
            </Button>
          </th>
          <th
            className={SurveyUtils.addClassForTableHeader("updatedBy", sortTableTemplateBy, sortTableTemplateAscending)}
          >
            <Button variant="link" onClick={() => onSortColumn("updatedBy")}>
              <FormattedMessage id="templateList.updatedBy" />
              {SurveyUtils.sortIcon("updatedBy", sortTableTemplateBy, sortTableTemplateAscending)}
            </Button>
          </th>
          <th className="number">
            <FormattedMessage id="templateList.version" />
          </th>
          <th
            className={SurveyUtils.addClassForTableHeader("language", sortTableTemplateBy, sortTableTemplateAscending)}
          >
            <Button variant="link" onClick={() => onSortColumn("language")}>
              <FormattedMessage id="templateList.language" />
              {SurveyUtils.sortIcon("language", sortTableTemplateBy, sortTableTemplateAscending)}
            </Button>
          </th>
          <th className="actions">
            <FormattedMessage id="templateList.preview" />
          </th>
        </tr>
      </thead>
      <TemplateListTableRows {...props} />
    </BootstrapTable>
  );
};

TemplateListTable.propTypes = {
  roles: PropTypes.array,
  sortColumn: PropTypes.func,
  sortTableTemplateBy: PropTypes.string,
  sortTableTemplateAscending: PropTypes.bool
};

export default TemplateListTable;
